import { Flex, Form } from 'antd';
import Button from 'components/Button';
import TextArea from 'antd/es/input/TextArea';
import useMessage from 'antd/es/message/useMessage';
import UtilitySummary from 'screens/system-utils/shared/components/UtilitySummary';
import useImportInvoiceMutation from '../hooks/useImportInvoiceMutation';

const ImportInvoice = () => {
  const [message, contextHolder] = useMessage();
  const { mutateAsync, isPending } = useImportInvoiceMutation({});

  const handleImportInvoice = async (values: { invoiceId: string }) => {
    const commaSeparatedInvoiceIds = values.invoiceId?.toString();
    if (!commaSeparatedInvoiceIds) {
      message.error('No invoice IDs provided.');
      return;
    }

    const invoiceIds = commaSeparatedInvoiceIds.split(',');
    const successInvoices: string[] = [];
    const failedInvoices: string[] = [];

    try {
      await Promise.all(
        invoiceIds.map(async (id) => {
          try {
            const data = await mutateAsync({ invoiceId: id });
            if (data) successInvoices.push(id);
          } catch {
            failedInvoices.push(id);
          }
        }),
      );

      let msg = '';

      if (successInvoices.length)
        msg = `Import successful for ${successInvoices.length} invoices`;

      if (failedInvoices.length) {
        msg += ` ${successInvoices?.length ? 'and' : 'Import'} failed for ${failedInvoices.length} invoices`;
      }
      message.info(msg);
    } catch (error) {
      console.error(
        'Unexpected error during the invoice import process:',
        error,
      );
    }
  };

  return (
    <Flex vertical>
      {contextHolder}
      <UtilitySummary
        title="Import Invoice"
        description="Enter one or more invoice id(s) to import into the platform."
      />
      <Form style={{ width: '100%' }} onFinish={handleImportInvoice}>
        <Flex gap={8} vertical align="flex-end">
          <Form.Item
            style={{ width: '100%' }}
            name="invoiceId"
            hasFeedback
            help="Please enter comma separated invoice id(s) without spaces eg:123 OR 123,456,789"
            rules={[
              { required: true, message: 'Please enter invoice id' },
              {
                pattern: /^\d+(,\d+)*$/,
              },
            ]}
          >
            <TextArea placeholder="Enter Invoice Id" rootClassName="mb-1" />
          </Form.Item>
          <Button htmlType="submit" type="primary" loading={isPending}>
            Import Invoice
          </Button>
        </Flex>
      </Form>
    </Flex>
  );
};

export default ImportInvoice;
